import {useEffect} from "react";
import {useAllStore} from "@/Stores/useAllStore";

export default function usePopstateButton() {
    const setPopstateButton = useAllStore((state) => state.setPopstateButton);

    useEffect(() => {
        const onPopstate = () => {
            setPopstateButton(true);
        };

        window.addEventListener('popstate', onPopstate);

        return () => {
            window.removeEventListener('popstate', onPopstate);
        };
    }, []);
}
